<template>
	<SOSlotBase :bg-white="true" :loading="pageSetting.loading">
		<template v-slot:loading-page>
			<SOLoadingPage/>
		</template>

		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Riwayat Perubahan Data'"
				:type="'back'"
				@back="back"
			/>
		</template>

		<template v-slot:content>
			<div class="p-x-20 p-y-8 bg-grey">
				<div class="f-regular f-14 f-c-midgrey">
					Konsumen: {{ customer.nama_customer }}
				</div>
			</div>
			<div class="p-l-8 p-r-20 p-y-20 tl-wrapper" v-if="riwayat.data !== null">
				<SOTimeline v-for="(data, i) in reversedData" :key="i">
					<template v-slot:title>
						<div class="d-flex align-items-end">
							<div class="f-regular f-16 f-c-black m-r-4">
								{{ $moment(Object.keys(data)[0].split("_")[1], "DD-MM-YYYY").format("dddd, DD MMMM YYYY") }}
							</div>
							<div class="f-regular f-14 f-c-midgrey">
								({{ data[Object.keys(data)[0]].total_ubahan }}x perubahan)
							</div>
						</div>
					</template>
					<template v-slot:content>
						<SOTimelineCard
							v-for="(perubahanData) in data[Object.keys(data)[0]].reversedData"
							:key="Object.keys(perubahanData)[0]"
							:title="`${Object.keys(perubahanData)[0]} ${timezone}`"
							:id="'id-' + Object.keys(perubahanData)[0].replace(/[:]/g, '')"
							:is-content-show="Object.keys(data[Object.keys(data)[0]].reversedData[0])[0] === Object.keys(perubahanData)[0]"
						>
							<template v-slot:content>
								<div v-if="perubahanData[Object.keys(perubahanData)[0]].tipe !== 'init'">
									<div class="p-y-12"
									     :class="{'border-bottom': perubahanData[Object.keys(perubahanData)[0]].data.length - i !== 1}"
									     v-for="(item, i) in perubahanData[Object.keys(perubahanData)[0]].data"
									>
										<span class="f-regular f-14 f-c-black p-r-16">{{ item.title }}</span>
										<span class="f-regular f-14 f-c-midgrey"
										      v-if="item.title === 'Tanggal Lahir'">
											{{ $moment.unix(Math.ceil(item.from / 1000)).format("DD MMMM YYYY") }}
											<i class="fas fa-arrow-right f-12 p-x-8"></i>
											{{ $moment.unix(Math.ceil(item.to / 1000)).format("DD MMMM YYYY") }}
										</span>
										<span class="f-regular f-14 f-c-midgrey"
										      v-else-if="item.title === 'Jenis Kelamin'">
											{{ item.from === 1 ? "Laki-laki" : "Perempuan" }}
											<i class="fas fa-arrow-right f-12 p-x-8"></i>
											{{ item.to === 1 ? "Laki-laki" : "Perempuan" }}
										</span>
										<span class="f-regular f-14 f-c-midgrey" v-else>
											{{ item.from }}
											<i class="fas fa-arrow-right f-12 p-x-8"></i>
											{{ item.to }}
										</span>
									</div>
								</div>
								<div v-else class="p-y-12 border-bottom">
									<img src="@/assets/icons/alert-info.svg" alt="" class="p-r-12">
									<span class="f-regular f-14 f-c-midgrey">
										Konsumen ditambahkan
									</span>
								</div>
							</template>
						</SOTimelineCard>
					</template>
				</SOTimeline>
			</div>

			<div class="flex-1" v-else>
				<div class="empty-state">
					<img class="img-fluid" src="@/assets/icons/empty.svg" alt="">
					<div class="f-16 f-c-midgrey">Konsumen ini belum memiliki perubahan data apapun.</div>
				</div>
			</div>
		</template>
	</SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex"

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import SOTimeline from "@/so-components/global/ui/SOTimeline";
import SOTimelineCard from "@/so-components/global/ui/SOTimelineCard";

export default {
	name: "CustomerRiwayatPerubahan",
	components: {
		SOSlotBase,

		SOLoadingPage,
		SOTitleBar,

		SOTimeline,
		SOTimelineCard,
	},
	computed: {
		...mapGetters("customerModule", {
			riwayat: "getRiwayat",
			customer: "getDetailCustomer",
		})
	},
	data() {
		return {
			idcustomer: "",
			reversedData: [],
			pageSetting: {
				loading: true,
			},
			timezone: ""
		}
	},
	mounted() {
		this.idcustomer = this.$route.params.idcustomer
		this.fetchDetailCustomer()
		this.getRiwayat()
		this.timezone = this.getTimezone()
	},
	methods: {
		back() {
			this.$router.back()
		},
		async fetchDetailCustomer() {
			const res = await this.$store.dispatch("customerModule/fetchDetailCustomer", this.idcustomer)
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		async getRiwayat() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("customerModule/fetchRiwayat", this.idcustomer)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.back()
				// return
			}
			this.doReverseData()
		},
		doReverseData() {
			for (let i = 0; i < Object.keys(this.riwayat.data).length; i++) {
				let riwayatObj = {}

				this.riwayat.data[Object.keys(this.riwayat.data)[i]].reversedData = []
				for (let j = Object.keys(this.riwayat.data[Object.keys(this.riwayat.data)[i]].data).length - 1; j >= 0; j--) {
					let itemRiwayatObj = {}
					itemRiwayatObj[Object.keys(this.riwayat.data[Object.keys(this.riwayat.data)[i]].data)[j]] =
						this.riwayat.data[Object.keys(this.riwayat.data)[i]].data[Object.keys(this.riwayat.data[Object.keys(this.riwayat.data)[i]].data)[j]]
					this.riwayat.data[Object.keys(this.riwayat.data)[i]].reversedData = [
						...this.riwayat.data[Object.keys(this.riwayat.data)[i]].reversedData,
						itemRiwayatObj
					]
				}

				riwayatObj[Object.keys(this.riwayat.data)[i]] = this.riwayat.data[Object.keys(this.riwayat.data)[i]]
				this.reversedData = [...this.reversedData, riwayatObj]
			}
			console.log("this.reversedData", this.reversedData)
		},
	}
}
</script>

<style scoped>
.tl-item {
	padding: 0;
}
</style>